import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import * as _ from 'lodash';
import { map } from 'rxjs/operators';

import { getEmbeddedCollection } from '@mode/shared/util-halogen';
import { ModeHalResource, ReportTypes } from '@mode/shared/contract-common';
import { OrgTypes } from '@mode/shared/contract-common';
import { BugsnagService } from '@mode/shared/util-error-handling';
import { OrganizationHelpers } from '@mode/legacy/data-access-model-js';

export class MoveSpaceModalService {
  static $inject = ['ModeCollection', 'HttpClient'];

  constructor(
    private ModeCollection,
    private $http: HttpClient,
    private _bugsnagService: BugsnagService
  ) {}

  nonPrivateCommunityIfPublic(space: any, report: any) {
    return (
      space.space_type !== 'private' &&
      (space.space_type !== 'community' || !report.run_privately) &&
      space.token !== report.space_token
    );
  }

  getCustomSpaces(owner: OrgTypes.Organization): Promise<any[]> {
    return this.$http
      .get<ModeHalResource>(owner.links.moveToSpaces)
      .pipe(map((resource) => getEmbeddedCollection(resource, 'spaces')))
      .toPromise();
  }

  async ensureReportCollection(spaces, report, owner: OrgTypes.Organization) {
    const moveableCollections = spaces;
    const collectionTokens = spaces.map(({ tokens }) => tokens);
    const currentReportsCollectionToken = report.space_token;

    if (collectionTokens.includes(currentReportsCollectionToken)) {
      return moveableCollections;
    } else {
      return moveableCollections.concat(await this.fetchReportCollection(report, owner));
    }
  }

  fetchReportCollection(report, owner: OrgTypes.Organization) {
    return report.space().catch((error: HttpErrorResponse) => {
      // Allow admin to see the list of collections to move another user personal report.
      if (error.status === 403 && owner.membershipType === 'admin') {
        return [];
      } else {
        this._bugsnagService.notify(error);
      }
    });
  }

  getCurrentSpace(spaces: any, reportSpaceToken: any): any {
    return _.find(spaces, (space: any) => space.token === reportSpaceToken);
  }

  getFilteredSpaces(spaces: any, report: any) {
    return spaces.filter((space) => this.nonPrivateCommunityIfPublic(space, report));
  }

  getFilteredAndSortedSpaces(spaces: any, report: any) {
    return this.getFilteredSpaces(spaces, report).sort((a, b) => a.name.localeCompare(b.name));
  }

  getSpacesAccessDetails(spaces: any) {
    const accessDetails = {};

    spaces.forEach((space) => {
      const accessLevel = space.default_access_level;
      let accessDetail: { icon: string; text: string };

      if (accessLevel === 'view') {
        accessDetail = {
          icon: 'icon-building-view',
          text: 'All Members can View',
        };
      } else if (accessLevel === 'edit') {
        accessDetail = {
          icon: 'icon-building-edit',
          text: 'All Members can Edit',
        };
      } else {
        accessDetail = {
          icon: 'icon-lock',
          text: 'Restricted',
        };
      }

      accessDetails[space.token] = accessDetail;
    });

    return accessDetails;
  }

  isDataset(report): boolean {
    return report?.type === ReportTypes.ReportType.DatasetReport;
  }

  isDatasetReportPublished(report) {
    const isDataset = this.isDataset(report);
    if (isDataset) {
      return report._resource.thoughtspot_published_at !== null;
    }
    return false;
  }
}
